import clsx from 'clsx'
import { Controller, useForm } from 'react-hook-form'
import { Col, Input, Label, Modal, Row, RowProps } from 'components/common'
import { CustomizedModalProps } from './types'

type FormInputs = {
  firstName: string
  lastName: string
  company: string
  zip: string
  prefecture: string
  city: string
  address1: string
  address2: string
  phone: string
}

export interface BillingInfoEditModalProps
  extends Omit<CustomizedModalProps, 'onOk'> {
  defaultValues: FormInputs
  onOk: () => void
}

const rowProps: RowProps = {
  className: clsx('mb-6'),
  gutter: 16,
}

export const BillingInfoEditModal = ({
  defaultValues,
  onOk,
  ...rest
}: BillingInfoEditModalProps): JSX.Element => {
  const { control, handleSubmit } = useForm<FormInputs>({})

  const onSubmit = (inputs: FormInputs) => {
    onOk()
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal
          title={'請求先住所を編集する'}
          okText={'保存する'}
          cancelText={'キャンセル'}
          {...rest}
        >
          <Row {...rowProps}>
            <Col span={12}>
              <Label>姓</Label>
              <Controller
                name={'lastName'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
            <Col span={12}>
              <Label>名</Label>
              <Controller
                name={'firstName'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Label>会社</Label>
              <Controller
                name={'company'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={12}>
              <Label>郵便番号</Label>
              <Controller
                name={'zip'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
            <Col span={12}>
              <Label>都道府県</Label>
              <Controller
                name={'prefecture'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Label>市区町村</Label>
              <Controller
                name={'city'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Label>住所</Label>
              <Controller
                name={'address1'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps}>
            <Col span={24}>
              <Label>建物名、部屋番号など</Label>
              <Controller
                name={'address2'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
          <Row {...rowProps} className={clsx('mb-0')}>
            <Col span={24}>
              <Label>電話番号</Label>
              <Controller
                name={'phone'}
                control={control}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
          </Row>
        </Modal>
      </form>
    </>
  )
}
